import React from 'react';
import { TDR } from 'tdr-common';
import { InventorySpecialEventsSection } from '../../inventory-carousel/InventorySpecialEventsSection';

export type EventsSectionProps = {
	restaurant: TDR.Restaurant;
};

export function EventsSection({ restaurant }: EventsSectionProps) {
	return (
		<InventorySpecialEventsSection restaurant={restaurant} />
	);
}
